import { api } from './format.js';
import { codeStep, setupApp } from './two-factor-ui.js';

const form = document.getElementById('login-form');
const error = document.getElementById('login-error');

// Only return to dashboard pages after logging in (never to another site).
const next = new URLSearchParams(location.search).get('next');
// The #tab part of the address never reaches the server, so it stays on this page's address: keep it.
const safeNext = next && next.startsWith('/dashboard/') && !next.startsWith('/dashboard/login') ? next : './';
const target = safeNext.includes('#') ? safeNext : safeNext + location.hash;

// Sign-up, when it's open.
api('/auth/options')
  .then((o) => (document.getElementById('signup-link').hidden = !o.signup))
  .catch(() => {});

// Already logged in: skip the form.
fetch('/api/auth/me').then((res) => {
  if (res.ok) location.replace(target);
});

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const submit = form.querySelector('[type=submit]');
  submit.disabled = true;
  error.hidden = true;
  try {
    const r = await api('/auth/login', {
      method: 'POST',
      body: { email: form.elements.email.value, password: form.elements.password.value },
    });
    // Two-factor authentication: a code from the app comes next; or, when the company requires it and it isn't set up yet, the setup.
    if (r.twoFactor) return twoFactor(r);
    location.replace(target);
  } catch (err) {
    error.textContent = err.message;
    error.hidden = false;
    form.elements.password.select();
    submit.disabled = false;
  }
});

/** The step after the password: the code, or setting the app up first. */
function twoFactor(r) {
  const step = document.getElementById('login-step');
  form.hidden = true;
  document.getElementById('signup-link').hidden = true;
  step.hidden = false;
  const title = document.getElementById('login-title');
  const restart = () => location.reload();
  if (r.twoFactor === 'code') {
    title.textContent = 'Two-factor authentication';
    codeStep(step, { challenge: r.challenge, onDone: () => location.replace(target), onRestart: restart });
  } else {
    title.textContent = 'Set up two-factor authentication';
    step.before(Object.assign(document.createElement('p'), { className: 'muted', textContent: 'Your company requires two-factor authentication. Set it up with an authenticator app to continue.' }));
    setupApp(step, { challenge: r.challenge, onDone: () => location.replace(target), onRestart: restart });
  }
}
